define([
    "dojo/_base/declare",
    "csi/config",
    "csi/form/Widget"
], function(declare, config, FormWidget) {
	return declare(FormWidget, {
		getFieldStore: function(/*Field*/field, /*String*/value) {
			if (field.getControlName() == "ThemeBOMTypeExceptionReport") {
				return config.getSubtypeStore("ApparelBOM");
			}
			return this.inherited(arguments);
		}
	});
});
